export default __webpack_public_path__ + "static/media/successicon-12.0cae91eb.png";